import React from 'react'
import TrainingBanner from '../Training/TrainingBanner'
import HealthcareFacility from '../../Industries/Healthcare/HealthcareFacility';
import HealthcareFaq from '../../Industries/Healthcare/HealthcareFaq';
import ServiceFast from './ServiceFast';
// import ServiceDemand from './ServiceDemand';
import ServiceIndia from './ServiceIndia';
import ServiceEquipment from './ServiceEquipment';
import InstallationService from '../Installation/InstallationService';

const Banner = {
  image: "/assets/images/service-banner.webp",
  heading: "Breakdowns Cost More Than A Service Contract.",
  description: "Reactive repairs, lost production, and emergency callouts add up quickly. Supershine's equipment service keeps your machines maintained, monitored, and running reliably across every shift.",
  buttonText: "Learn More",
  link: "/contact",
}

const facilityData = {
  title: " Scheduled Maintenance That Prevents The Unplanned",
  description: "Structured maintenance programmes designed to catch wear before it becomes failure, extend equipment lifespan, and keep your industrial laundry operation running without costly interruptions.",
  items: [
    {
      icon: "/assets/images/service-facility-icon1.webp",
      heading: "Quarterly Inspection",
      description: "Scheduled visits every three months to check wear components, lubrication, connections, and performance before small issues develop into unplanned breakdowns."
    },
    {
      icon: "/assets/images/service-facility-icon2.webp",
      heading: "Annual Deep Service",
      description: "A full strip-down service covering all mechanical, electrical, and utility connections with component replacement where required to restore peak operating condition."
    },
    {
      icon: "/assets/images/service-facility-icon3.webp",
      heading: "Emergency Priority",
      description: "Contracted facilities receive priority response when urgent faults occur, with faster technician dispatch and parts availability ahead of standard service queue."
    },
  ]
};

const faqData = {
  title: "FAQs",
  description:
    "Straight answers about our service process so you know exactly what to expect when you call us.",
  buttonText: "Talk to an expert",
  buttonLink: "/contact",
  faqs: [
    {
      question: "  What Does Supershine Machine Service Include?",
      answer: "Every service visit covers fault diagnosis, mechanical and electrical inspection, component replacement where required, and a full test run before the technician leaves. We document what was found and what was done so you have a clear service record for each machine.",
    },
    {
      question: "How Often Should Machines Be Serviced?",
      answer:
        "High-usage industrial machines should be inspected quarterly with a full deep service annually. Facilities running multiple shifts or processing heavy daily volumes may require more frequent attention to stay ahead of wear-related failures.",
    },
    {
      question: " Do You Service All Types Of Laundry Machines?",
      answer:
        " Yes. We service washer extractors, tumble dryers, flatwork ironers, finishing equipment, and pressing machines across all major brands including the full range of equipment we supply and install.",
    },

    {
      question: "What Happens During A Service Visit?",
      answer:
        " The technician inspects the machine, identifies any faults or wear, confirms the repair scope with you, carries out the work using genuine parts, and tests the machine under operating conditions before signing off.",
    },

    {
      question: "Do You Use Genuine Spare Parts?",
      answer:
        " Yes. All components used in our service visits are genuine or quality-matched parts specified for your exact machine model to protect performance, warranty validity, and long-term reliability.",
    },

    {
      question: "How Quickly Can You Respond To A Breakdown?",
      answer:
        "Response times depend on your location and contract status. Facilities on a maintenance programme receive priority dispatch. For all other requests, our team works to get a technician on site as quickly as possible.",
    },
  ],
};

const ServiceFaq = {
  heading: " Our Most In-Demand Service Calls",
  description: "These are the faults we handle most often. If your issue is not listed, contact our team and we will assess and advise before booking a visit.",
  image: "/assets/images/service-demand-img.webp",
  alt: "Teenager Smiling",
  faqs: [
    {
      question: "Motor And Drive Failures",
      answer: "Worn motor windings, failed capacitors, and drive belt damage are among the most common causes of machines stopping mid-cycle. We diagnose the root cause and replace the correct component on the same visit.",
    },
    {
      question: "Stain Removal And Spot Treatment",
      answer: "Persistent staining after repeated wash cycles usually points to incorrect chemical dosing, wash temperature, or programme selection. We identify the cause and correct the process rather than just repeat the cycle.",
    },
    {
      question: "Water Inlet And Valve Faultss",
      answer: "Machines that fail to fill, overfill, or fill slowly typically have solenoid valve or pressure sensor issues. We test and replace the faulty component to restore correct fill behaviour across all wash programmes.",
    },
    {
      question: "Drum Bearing And Noise Issues",
      answer: "Grinding, banging, or excessive vibration during operation usually indicates bearing wear or drum imbalance. Left unaddressed, these faults accelerate damage to surrounding components significantly.",
    },
    {
      question: "Control Board And Programme Errors",
      answer: "Error codes, unresponsive controls, and programmes that fail to complete are often caused by control board faults or sensor failures. We diagnose electronically and repair or replace the affected component on site.",
    },
  ],

};


const Service = {
  heading: "What Happens <br> After You Contact Us",
  image: "/assets/images/book-service.webp",
  alt: "Supershine Service",
  faqs: [
    {
      number: "01",
      question: "Request Received",
      answer: "We log your machine details, fault description, and location, then confirm a technician visit with a clear timeframe so you know exactly when to expect us.",
    },
    {
      number: "02",
      question: "On-Site Assessment",
      answer: "Our technician inspects the machine, identifies the root cause of the fault, and confirms the repair scope and parts required before any work begins.",
    },
    {
      number: "03",
      question: "Service Execution",
      answer: "The repair is carried out on-site using genuine components, with the technician working to restore full operation as efficiently as possible on the same visit.",
    },
    {
      number: "04",
      question: "Final Check & Approval",
      answer: "The machine is tested under real operating conditions before the technician leaves, confirming the fault is fully resolved and the equipment is performing correctly.",
    },
  ],

};


const bannerData = {
        head: "Home",
        breadcrumb: [
            {
                slug: "/sales-service",
                name: "After  Sales Service "
            }
        ]
    }


export default function ServiceOn() {
  return (
    <>
      <TrainingBanner data={Banner}  breadcrumb={bannerData.breadcrumb}/>
      <ServiceFast />
      <ServiceEquipment />
      {/* <ServiceDemand data={ServiceFaq} /> */}
      <InstallationService data={Service} extraClass="servicepage-book" />
      <HealthcareFacility data={facilityData} extraClass="servicepage-program" />
      <ServiceIndia />
      <HealthcareFaq data={faqData} />
    </>
  )
}
